export default __webpack_public_path__ + "static/media/bridgeT_offline.2ba718b9.svg";